<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Lokasyon Tipi</label>
            <input type="text" class="form-control" v-model="value.Name" placeholder="Lokasyon Tipi" />
        </div>
        
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    },
    data(){
        return{
           
        }
    },
}
</script>

<style>

</style>